/**
 * Product Card Variant Selector
 * Handles variant selection on product cards and updates the add to cart button
 */

(function() {
  'use strict';

  /**
   * Initialize variant selectors
   */
  function initVariantSelectors() {
    const variantSelects = document.querySelectorAll('.t4s-pr-variant-select');
    
    if (variantSelects.length === 0) return;
    
    variantSelects.forEach(function(select) {
      // Remove any existing listeners to prevent duplicates
      select.removeEventListener('change', handleVariantChange);
      // Add change event listener
      select.addEventListener('change', handleVariantChange);
      
      // Set initial variant ID on the button
      updateAddToCartButton(select);
    });
  }

  /**
   * Handle variant selection change
   * @param {Event} event - Change event
   */
  function handleVariantChange(event) {
    const select = event.target;
    updateAddToCartButton(select);
  }

  /**
   * Update the add to cart button with selected variant ID
   * @param {HTMLSelectElement} select - The variant select element
   */
  function updateAddToCartButton(select) {
    const selectedVariantId = select.value;
    const selectedOption = select.options[select.selectedIndex];
    const isAvailable = selectedOption.getAttribute('data-available') === 'true';
    
    const wrapper = select.closest('.t4s-pr-variant-atc-wrapper');
    if (!wrapper) return;
    
    const atcButton = wrapper.querySelector('.t4s-pr-variant-atc');
    if (!atcButton) return;
    
    // Update variant ID
    atcButton.setAttribute('data-variant-id', selectedVariantId);
    
    // Update button state based on availability
    if (isAvailable) {
      atcButton.removeAttribute('disabled');
      atcButton.removeAttribute('aria-disabled');
      atcButton.classList.remove('disabled');
    } else {
      atcButton.setAttribute('disabled', 'disabled');
      atcButton.setAttribute('aria-disabled', 'true');
      atcButton.classList.add('disabled');
    }
  }

  /**
   * Initialize on DOM ready
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantSelectors);
  } else {
    initVariantSelectors();
  }

  /**
   * Re-initialize when new content is loaded (e.g., infinite scroll, filters)
   */
  document.addEventListener('shopify:section:load', initVariantSelectors);
  
  // Also listen for custom events that might load new products
  document.addEventListener('product:loaded', initVariantSelectors);
  
  // For AJAX pagination/filtering
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.querySelector) {
            const newSelects = node.querySelectorAll('.t4s-pr-variant-select');
            if (newSelects.length > 0) {
              initVariantSelectors();
            }
          }
        });
      }
    });
  });

  // Observe product containers for dynamic content
  const productContainers = document.querySelectorAll('.t4s-product, .t4s-products, .products-grid');
  productContainers.forEach(function(container) {
    observer.observe(container, {
      childList: true,
      subtree: true
    });
  });

})();

